var React = require('react');

function ThumbsUp (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("rect",{"x":"2","y":"39.57","width":"24","height":"50.02","rx":"12","key":0}),React.createElement("path",{"d":"M59.51,52.2H87.27a7.53,7.53,0,0,0,7.51-7.51h0a7.53,7.53,0,0,0-7.51-7.51H58.16S64,20.17,55,5.94c0,0-2.33-4.37-6.79-3.91,0,0-4.1-.46-6.05,4.19L41.88,7.8,41.7,9.48s.83,23.9-16.47,37.76","key":1}),React.createElement("path",{"d":"M86.77,52.16a7,7,0,0,1,5.45,6.64h0c0,3.8-3.38,6.91-7.51,6.91H59.32","key":2}),React.createElement("path",{"d":"M81.83,65.69a7.1,7.1,0,0,1,6,6.76h0c0,3.8-3.38,6.91-7.51,6.91h-21","key":3}),React.createElement("path",{"d":"M74.22,79.34c3.42.54,6,2.88,6,5.66h0c0,3.18-3.38,5.78-7.51,5.78H45a27.77,27.77,0,0,1-19.81-8.47","key":4})]));
}

ThumbsUp.defaultProps = {"className":"svg-thumbs-up","viewBox":"0 0 96.78 92.79","stroke":"#000000"};

module.exports = ThumbsUp;

ThumbsUp.default = ThumbsUp;
